var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TypeAhead',{ref:"autocomplete",attrs:{"src":_vm.srcComputed,"placeholder":"Por favor ingrese algun parametro","searching-text":"Buscando...","fetch":_vm.fetch,"render":_vm.render,"on-hit":_vm.onSelect,"get-response":_vm.getResponse}})}
var staticRenderFns = []

export { render, staticRenderFns }